import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import { useRelations } from '@hooks/useAgencyPublication'
import { useRelations as usePublicationRelations, generateUrls } from '@hooks/usePublication'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { AgencyPublicationModel } from '@models/types'

interface AgencyPublicationListItemProps {
  agencyPublication: AgencyPublicationModel,
}

const AgencyPublicationListItem = (props: AgencyPublicationListItemProps) => {
  const { agencyPublication: initAgencyPublication, ...restProps } = props

  const {
    publication,
    publication: {
      // @ts-expect-error TS2339
      id,
      // @ts-expect-error TS2339
      title,
    },
  } = useRelations(initAgencyPublication)

  const { provider } = usePublicationRelations(publication)

  const { editPublicationUrl } = generateUrls(publication)

  const { isBrandUser } = useCurrentUser()

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2339
      secondaryText={provider?.title}
      showCheckbox={!isBrandUser}
      title={title}
      {...restProps}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            href={`${editPublicationUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}

export default AgencyPublicationListItem
